/**
 * Allows forms to be separated into different <fieldset> groups and step between
 * @returns {[undefined]} []
 */
export function multiStepFormInit() {
  const forms = $('[data-js-form-multistep]').parent('form');

  if (forms.length > 0) {
    for (let f = 0; f < forms.length; f++) {
      handleStepChange(forms[f]);
    }
  }
}

// input - html element
function handleStepChange(form) {
  form = $(form);
  const $container = form.parent('.wpcf7');
  let thisCurrentStep = 1;
  const steps = form.find('.form__step');
  const needsValidation =
    form.find('[data-js-form-jquery-validate]').length > 0;
  const progressBar = form.find('.progress-indicator');

  if (progressBar.length > 0) {
    progressBar.attr({ 'aria-live': 'polite' });
  }

  function gotoStep(step) {
    setActiveStep(parseInt(step, 10));
  }

  function setActiveStep(currentStep) {
    const percentageComplete = `${parseInt(
      (100 * (currentStep - 1)) / steps.length,
      10,
    )}%`;

    steps.removeClass('is-visible');

    for (let i = 1; i <= steps.length; i++) {
      if (i === currentStep) {
        steps.eq(i - 1).attr('aria-hidden', false);
        steps.eq(i - 1).addClass('is-visible');
      } else {
        steps.eq(i - 1).attr('aria-hidden', true);
      }
    }

    setProgressBar(percentageComplete);

    if (thisCurrentStep !== currentStep && currentStep > 0) {
      let inputToFocus = steps
        .eq(currentStep - 1)
        .find('input:visible, select:visible, img:visible[tabindex="0"]');
      let currentFieldset = steps.eq(currentStep - 1);

      if (currentFieldset) {
        $([document.documentElement, document.body]).animate(
          {
            scrollTop: currentFieldset.offset().top - 300,
          },
          1000,
        );
      }

      if (inputToFocus) {
        inputToFocus.first().focus();
      }
    }

    thisCurrentStep = currentStep;
  }

  function setProgressBar(percentage) {
    if (progressBar.length > 0) {
      progressBar
        .find('.progress-indicator__bar__fill')
        .css('width', percentage);
      progressBar
        .find('.progress-indicator__message')
        .html(
          `<span class="sr-only">Form progress:</span> ${percentage} complete`,
        );
      progressBar.attr('aria-label', `Progress: ${percentage}`);
    }
  }

  function focusOnError() {
    const firstElement = $(
      'input.form__error:visible, select.form__error:visible',
    ).first();

    if (firstElement.length === 0) {
      return;
    }

    $([document.documentElement, document.body]).animate(
      {
        scrollTop: firstElement.offset().top - 300,
      },
      1000,
    );
    firstElement.focus();
  }

  function handleFormPageMove(e) {
    const toStep = e.currentTarget.getAttribute('data-js-multistep-goto');

    if (thisCurrentStep < toStep) {
      if (needsValidation && form.valid()) {
        gotoStep(toStep);
      } else if (!needsValidation) {
        gotoStep(toStep);
      } else {
        focusOnError();
      }
    } else if (thisCurrentStep > toStep) {
      gotoStep(toStep);
    }
  }

  // Set event listeners
  form.find('[data-js-multistep-goto]').on('click', (e) => {
    handleFormPageMove(e);
  });

  form.find('[data-js-multistep-goto]').on('keyup', (e) => {
    if (e.key === 'Enter') {
      handleFormPageMove(e);
    }
  });

  // prevent submission when pressing enter before the end of the form
  form.bind('keypress keydown keyup', ':input:not(textarea)', (e) => {
    if (e.keyCode == 13) {
      e.preventDefault();
    }
  });

  // Setup accessiblity
  setActiveStep(parseInt(thisCurrentStep, 10));

  // Set submission states
  form.on('submit', () => {
    form
      .find('input[type=submit]')
      .addClass('btn--disabled')
      .attr('disabled', 'true');
  });

  $container.on('wpcf7invalid', (e) => {
    setTimeout(() => {
      $(e.target)
        .find('input[type=submit]')
        .removeClass('btn--disabled')
        .attr('disabled', 'false');
      $([document.documentElement, document.body]).animate(
        {
          scrollTop:
            $(e.target).find('.wpcf7-response-output').offset().top - 300,
        },
        1000,
      );
      $(e.target).find('.wpcf7-response-output').focus();
    }, 500);
  });

  $container.on('wpcf7mailsent', () => {
    setActiveStep(-1);
    setProgressBar('100%');
  });
}
